export class CuadroRetencion {
    codigo: string;
    documento: string;
    soporte: string;
    ag: Number;
    ac: Number;
    ct?: boolean;
    e?: boolean;
    md?: boolean;
    s?: boolean;
    procedimiento?: string;
  }


// WEBPACK FOOTER //
// ./src/app/shared/models/utilidades.model.ts